'use strict';
import $ from 'jquery';

export default class Nav {
    static init() {
        $('header').each((index, el) => {
            new Nav($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.burger').on('click', this.onBurgerClick.bind(this));
        this.el.find('.menu-item-has-children').on('click', this.onParentClick.bind(this));
        $(window).on('resize', this.position.bind(this));
        $(document).on('click', this.onDocumentClick.bind(this));
    }

    onBurgerClick(e) {
        e.preventDefault();
        const $burger = $(e.currentTarget);
        $burger.toggleClass('open');
    }

    onParentClick(e) {
        const $li = $(e.currentTarget);
        if ($li.attr('href') === '#')
            e.preventDefault();
        if (false === this.el.find('ul.open').is($li.find('ul')))
            this.el.find('ul.open').removeClass('open');
        $li.find('ul').toggleClass('open');
        this.position();
    }

    // Handle clicks outside of the nav to close any open dropdown menu
    onDocumentClick(e) {
        if (this.el.find('ul.open').length > 0) {
            if (!this.el.get(0).contains($(e.target).get(0))) {
                this.el.find('ul.open').removeClass('open');
            }
        }
    }

    position(e) {
        const openUl = this.el.find('ul.open');
        if (openUl.length > 0) {
            if (openUl.offset().left + openUl.width() > $(window).width()) {
                openUl.css('left', 'unset').css('right', 0);
            }
        }
    }
}